import React from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AccountsandFinanceurl } from "../../../../config";
import { mpesaProviderFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

const MpesaProviderForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const initialValues = {
    id: props.data ? props.data.id : "",
    providerName: props.data ? props.data.providerName : "",
    shortCode: props.data ? props.data.shortCode : "",
    businessCode: props.data ? props.data.businessCode : "",
    contactNumber: props.data ? props.data.contactNumber : "",
    email: props.data ? props.data.email : "",
    createdDate: props.data ? props.data.createdDate : "",
    createdBy: props.data ? props.data.createdBy : userId,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        id,
        providerName,
        shortCode,
        businessCode,
        contactNumber,
        email,
        createdDate,
        createdBy,
        companyId,
      } = values;

      const mutationData = props.isEditing
        ? {
            id,
            providerName,
            shortCode,
            businessCode,
            contactNumber,
            email,
            createdDate,
            createdBy,
          }
        : {
            providerName,
            shortCode,
            businessCode,
            contactNumber,
            email,
            createdDate: new Date().toISOString(),
            createdBy: userId,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateMpesaProvider" : "createMpesaProvider",
        mutationData,
        "functionparams",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `MPESA provider ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={mpesaProviderFields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit MPESA Provider" : "Create MPESA Provider"}
      subtitle={
        props.isEditing
          ? "Edit an Existing MPESA Provider"
          : "Create a New MPESA Provider"
      }
    />
  );
};

export default MpesaProviderForm;
